<template lang="pug">
    d2-container
      el-form(:inline='true', :model='dataForm'  size='mini' label-position='right' label-width='75px' label-suffix=':')
        el-row(:span='24')
          el-col(:md='6' :sm='8')
             el-form-item(label='订单编号')
                el-input.inputWidth(v-model='dataForm.orderId', placeholder='订单编号', clearable='')
          el-col(:md='6' :sm='8')
             el-form-item(label='教练手机号')
                el-input.inputWidth(v-model='dataForm.coachMobile', placeholder='教练手机号', clearable='')
          el-col(:md='6' :sm='8')
             el-form-item(label='教练姓名' label-position='right')
                el-input.inputWidth(v-model='dataForm.coachName', placeholder='教练姓名', clearable='')
          el-col(:md='6' :sm='8')
             el-form-item(label='学员账号' label-position='right')
                el-input.inputWidth(v-model='dataForm.accountId', placeholder='学员账号', clearable='')
        el-row(:span='24')
          el-col(:md='6' :sm='8')
             el-form-item(label='学员姓名' label-position='right')
                el-input.inputWidth(v-model='dataForm.name', placeholder='学员姓名', clearable='')
          el-col(:md='6' :sm='8')
             el-form-item(label='订单日期')
                 el-date-picker(style='width:210px', v-model='dataForm.rangeTime' range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd")
          el-col(:md='6' :sm='8')
             el-form-item(label='状态' )
                el-select.inputWidth(v-model='dataForm.status' clearable)
                   el-option(label="未支付" value=0)
                   el-option(label="支付中" value=1)
                   el-option(label="支付成功" value=2)
                   el-option(label="支付失败" value=3)
                   el-option(label="支付已关闭" value=9)
                   el-option(label="超时" value=4)
                   el-option(label="申请退款" value=5)
                   el-option(label="退款中" value=6)
                   el-option(label="退款成功" value=7)
                   el-option(label="退款失败" value=8)
                   el-option(label="退款已取消" value=10)
        el-row(:span='24')
          el-col(:span='12' style="padding-bottom:15px;")
            el-button(@click='exportExcel()' type='primary' style='float:left;' v-if="isAuth('cb:competitionOrder:CoachUpload')" ) 列表导出
          el-col(:span='12' style="padding-bottom:15px;")
            el-button(@click='getDataList()',type='primary',icon='el-icon-search' style='float:right;') 查 询
          el-col(:span='24' style="padding-bottom:15px;")
            span(style='float:right;color:red;') ￥{{totalMoney}}元
            span(style='float:right;') 总金额：
        el-table(:data="tableData" style="width: 100%" v-loading='dataListLoading' border)
            el-table-column(prop='orderNo' width="180" header-align='center',align='center',label='订单编号'  )
            el-table-column(prop='createTime' width="180" header-align='center',align='center',label='订单日期'  )
            el-table-column(prop='coachName' header-align='center',align='center',label='教练姓名')
            el-table-column(prop='coachMobile' header-align='center',align='center',label='教练手机号')
            el-table-column(prop='userName' header-align='center',align='center',label='学员姓名')
            el-table-column(prop='account' header-align='center',align='center',label='学员账号')
            el-table-column(prop='subscribeDate' width="180" header-align='center',align='center',label='日期')

            el-table-column( header-align='center',align='center',label='时间段')
                template(slot-scope="scope")
                    font {{ scope.row.subscribeTime}}
            el-table-column(prop='placeName' header-align='center',align='center',label='场地')
            el-table-column(header-align='center',align='center',label='支付金额')
              template(slot-scope="scope" v-if="scope.row.amount")
                font ￥{{ parseFloat(scope.row.amount).toFixed(2) }}元
            el-table-column( header-align='center',align='center',label='退款比例')
               template(slot-scope="scope" v-if="scope.row.refundRate")
                font {{ scope.row.refundRate }}%
            el-table-column(header-align='center',align='center',label='退款金额')
               template(slot-scope="scope" v-if="scope.row.refundAmount")
                font ￥{{ parseFloat(scope.row.refundAmount).toFixed(2) }}元
            el-table-column(prop='payStateName' header-align='center',align='center',label='状态')
            el-table-column(prop='remark' header-align='center',align='center',label='备注')
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 30]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        //- detail(v-if='detailVisiable', ref="detail", @refreshDataList='getDataList')
</template>
<script>
import table from './table.js'
import { get30DaysArray } from '@/util/dateUtils'

export default {
  name: 'finance-competitionOrder-reserveSite',
  data () {
    return {
      table: {
        columns: table.columns,
        data: null,
        size: 'mini',
        stripe: true,
        border: true
      },
      isCollapse: true,
      detailVisiable: false,
      dataForm: {
        // 约场地订单查询参数
        accountId: '',
        rangeTime: [],
        beginTime: '',
        endTime: '',
        name: '',
        orderId: '',
        status: '',
        coachName: '',
        coachMobile: '',
        limit: '',
        page: ''
      },
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      totalMoney: undefined
    }
  },
  mounted () {
    this.dataForm.rangeTime = get30DaysArray()
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      let [startTime = null, endTime = null] = this.dataForm.rangeTime || []
      this.dataForm.beginTime = startTime
      this.dataForm.endTime = endTime
      this.dataForm.limit = this.pageSize
      this.dataForm.page = this.pageIndex
      console.log(this.dataForm)
      //   TODO 约场地订单接口,需替换
      this.$http({
        url: this.$http.adornUrl('/pxSubscribe/order/reserve-list'),
        method: 'POST',
        params: this.$http.adornParams({
          limit: this.pageSize,
          page: this.pageIndex
        }),
        data: this.dataForm
      }).then((data) => {
        if (data && data.code === 0) {
          this.tableData = data.data.rows
          this.totalPage = data.data.total
        } else {
          this.tableData = []
          this.totalPage = 0
          this.totalMoney = 0
        }
        this.dataListLoading = false
      })
      this.$http({
        url: this.$http.adornUrl('/pxSubscribe/order/reserve-list-money'),
        method: 'POST',
        params: this.$http.adornParams({
          limit: this.pageSize, //必须放  不然过不去
          page: this.pageIndex
        }),
        data: this.dataForm
      }).then((data) => {
        if (data && data.code === 0) {
          this.totalMoney = data.data
          //   this.tableData = data.data.rows
          //   this.totalPage = data.data.total
        } else {
          this.totalMoney = ''
        }
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    exportExcel () {
      //导出列表
      let [startTime = null, endTime = null] = this.dataForm.rangeTime || []
      this.dataForm.beginTime = startTime
      this.dataForm.endTime = endTime
      this.dataForm.limit = this.pageSize
      this.dataForm.page = this.pageIndex
      console.log(this.dataForm)
      //   TODO 约场地订单接口,需替换
      this.$http({
        url: this.$http.adornUrl('/pxSubscribe/order/reserve-list'),
        method: 'POST',
        params: this.$http.adornParams({
          limit: 10000000,
          page: 1
        }),
        data: this.dataForm
      }).then((data) => {
        if (data && data.code === 0) {
          if (!data.data || data.data.rows.length === 0) {
            this.$message.info('没有要导出的数据!')
            return
          }
          let exportData = data.data.rows
          for (let i of exportData) {
            i.amount = i.amount ? '¥' + i.amount + '元' : ''
            i.refundRate = i.refundRate ? i.refundRate + '%' : ''
            i.refundAmount = i.refundAmount ? '¥' + i.refundAmount + '元' : ''
            // i.placeModeName = i.placeMode.name
            // i.placeModeId = i.placeMode.id
            // i.placeModeType = i.placeMode.type
            // i.placeModeFieldNo = i.placeMode.fieldNo
          }
          console.log('导出的订单数据：', exportData)
          this.$export
            .excel({
              columns: this.table.columns,
              data: exportData,
              title: '约教练订单'
            })
            .then(() => {
              this.$message.success('导出表格成功')
            })
        }
      })
    }
  }
}
</script>
<style>
.el-form--inline .el-form-item__label {
  width: 91px !important;
}
.inputWidth {
  width: 210px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}
</style>
<style >
/* 操作三点 菜单样式 */
@import '../../../css/opr3dot.css';
</style>
